// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* soft, minimal palette and refined interactions; keeps all your class names */

/* Theme tokens (header-only scope) */
:root {
  --hdr-bg: #ffffff;
  --hdr-border: #e6ebf2;
  --hdr-shadow-sm: 0 1px 2px rgba(16, 24, 40, 0.06),
    0 1px 3px rgba(16, 24, 40, 0.04);
  --hdr-surface: #f8fafc;
  --hdr-surface-2: #f1f5f9;

  --hdr-text: #0f172a;
  --hdr-muted: #64748b;

  --hdr-accent: #2563eb;
  --hdr-accent-600: #2563eb;
  --hdr-accent-100: #eff6ff;
  --hdr-accent-50: #f5faff;

  --success: #16a34a;
  --warning: #f59e0b;
  --danger: #ef4444;
}

/* Header shell */
.dashboard-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.875rem 1.25rem;
  background-color: var(--hdr-bg);
  border-bottom: 1px solid var(--hdr-border);
  box-shadow: var(--hdr-shadow-sm);
  position: relative;
}

/* Active section title */
.active-section-display {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
}
.active-section-value {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--hdr-accent-600);
  letter-spacing: 0.2px;
}

/* Buttons: menu/icon/ghost */
.menu-button,
.icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 0.5rem;
  color: var(--hdr-muted);
  background-color: transparent;
  border: 1px solid transparent;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease,
    border-color 0.2s ease, transform 0.08s ease;
}
.menu-button {
  margin-right: 0.25rem;
}
.menu-button:hover,
.icon-button:hover {
  background-color: var(--hdr-surface-2);
  color: var(--hdr-text);
  border-color: var(--hdr-border);
}
.menu-button:active,
.icon-button:active {
  transform: translateY(1px);
}

/* Search (optional: add in JSX if you use it) */
.search-container {
  position: relative;
  width: 100%;
  max-width: 420px;
}
.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
}
.search-input {
  width: 100%;
  padding: 0.625rem 0.875rem 0.625rem 2.25rem;
  border-radius: 0.5rem;
  border: 1px solid var(--hdr-border);
  background-color: var(--hdr-surface);
  font-size: 0.9rem;
  transition: box-shadow 0.2s ease, border-color 0.2s ease,
    background-color 0.2s ease;
}
.search-input:focus {
  outline: none;
  border-color: var(--hdr-accent);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
  background-color: #fff;
}

/* Right side actions */
.header-actions {

    display: flex;
    flex-direction: row;
    justify-content: right;
    align-items: center;
    /* flex-wrap: wrap; */
    width: 100%;

}

/* Ghost button (Admin/Head/Employee/Partner Panel) */
.header-button {
  padding: 0.5rem 0.875rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--hdr-text);
  background-color: var(--hdr-surface);
  border: 1px solid var(--hdr-border);
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease,
    border-color 0.2s ease;
}
.header-button:hover {
  background-color: var(--hdr-surface-2);
}

/* Notification badge */
.notification-wrapper {
  position: relative;
}
.notification-button {
  position: relative;
}
.notification-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background-color: var(--danger);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  border: 2px solid #fff;
}

/* Notifications dropdown */
.notifications-dropdown {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  width: 320px;
  background-color: #fff;
  border: 1px solid var(--hdr-border);
  border-radius: 0.75rem;
  box-shadow: 0 12px 24px rgba(2, 8, 20, 0.08);
  z-index: 50;
  overflow: hidden;
  animation: slideDown 0.18s ease;
}
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.notifications-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 0.875rem;
  border-bottom: 1px solid var(--hdr-border);
}
.notifications-header h3 {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--hdr-text);
}
.close-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 0.5rem;
  color: var(--hdr-muted);
  background: transparent;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.2s ease;
}
.close-button:hover {
  background-color: var(--hdr-surface-2);
  color: var(--hdr-text);
  border-color: var(--hdr-border);
}

.notifications-list {
  max-height: 320px;
  overflow-y: auto;
}
.notification-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.75rem 0.875rem;
  border-bottom: 1px solid var(--hdr-surface-2);
  transition: background-color 0.15s ease;
}
.notification-item:hover {
  background-color: var(--hdr-surface);
}
.notification-item.unread {
  background-color: var(--hdr-accent-50);
}
.notification-item.unread:hover {
  background-color: var(--hdr-accent-100);
}
.notification-item.past-due {
  background-color: #fef2f2;
} /* soft red for overdue */

.notification-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  color: #fff;
  flex-shrink: 0;
}
.notification-icon.blue {
  background-color: var(--hdr-accent);
}
.notification-icon.green {
  background-color: var(--success);
}
.notification-icon.amber {
  background-color: var(--warning);
}
.notification-icon.red {
  background-color: var(--danger);
} /* for past-due */

.notification-content {
  flex: 1 1;
}
.notification-text {
  margin: 0 0 0.25rem;
  font-size: 0.9rem;
  color: var(--hdr-text);
  line-height: 1.4;
}
.notification-time {
  margin: 0;
  font-size: 0.75rem;
  color: var(--hdr-muted);
}

.notifications-footer {
  padding: 0.625rem;
  border-top: 1px solid var(--hdr-border);
  text-align: center;
}
.view-all {
  width: 100%;
  padding: 0.5rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--hdr-accent-600);
  background-color: var(--hdr-accent-100);
  border: 1px solid transparent;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}
.view-all:hover {
  background-color: #e0efff;
  border-color: #d2e4ff;
}

/* User profile + dropdown */
.user-profile-wrapper {
  position: relative;
}
.user-profile {
  display: inline-flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.25rem 0.5rem 0.25rem 0.25rem;
  border-radius: 0.75rem;
  background-color: var(--hdr-surface);
  border: 1px solid var(--hdr-border);
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}
.user-profile:hover {
  background-color: var(--hdr-surface-2);
}
.user-avatar {
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid var(--hdr-border);
  background-color: var(--hdr-surface-2);
}
.user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.user-info {
  display: none;
}
@media (min-width: 1024px) {
  .user-info {
    display: flex;
    flex-direction: column;
  }
  .user-name {
    font-size: 0.875rem;
    font-weight: 600;
    color: var(--hdr-text);
  }
  .user-role {
    font-size: 0.75rem;
    color: var(--hdr-muted);
  }
}

.user-dropdown {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  width: 240px;
  background-color: #fff;
  border: 1px solid var(--hdr-border);
  border-radius: 0.75rem;
  box-shadow: 0 12px 24px rgba(2, 8, 20, 0.08);
  z-index: 50;
  overflow: hidden;
  animation: slideDown 0.18s ease;
}
.user-dropdown-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem;
  border-bottom: 1px solid var(--hdr-border);
}
.user-dropdown-avatar {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid var(--hdr-border);
}
.user-dropdown-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.user-dropdown-name {
  margin: 0 0 0.25rem;
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--hdr-text);
}
.user-dropdown-email {
  margin: 0;
  font-size: 0.75rem;
  color: var(--hdr-muted);
}

.user-dropdown-menu {
  padding: 0.5rem 0;
}
.user-dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.75rem 0.875rem;
  color: var(--hdr-text);
  text-decoration: none;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.user-dropdown-item:hover {
  background-color: var(--hdr-surface);
}
.user-dropdown-footer {
  padding: 0.5rem 0;
  border-top: 1px solid var(--hdr-border);
}
.user-dropdown-item.logout {
  color: var(--danger);
}
.user-dropdown-item.logout:hover {
  background-color: #fef2f2;
}

/* Theme toggle (if you wire it later) */
.theme-toggle {
  position: relative;
  width: 3rem;
  height: 1.5rem;
  border-radius: 999px;
  background-color: var(--hdr-surface-2);
  border: 1px solid var(--hdr-border);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.25rem;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}
.theme-toggle::after {
  content: "";
  position: absolute;
  left: 0.125rem;
  top: 0.125rem;
  width: 1.125rem;
  height: 1.125rem;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(2, 8, 20, 0.12);
  transition: left 0.25s ease, background-color 0.25s ease;
}
.theme-toggle .sun-icon {
  color: #f59e0b;
}
.theme-toggle .moon-icon {
  color: #94a3b8;
}
.theme-toggle.dark {
  background-color: #0b1220;
  border-color: #111827;
}
.theme-toggle.dark::after {
  left: calc(100% - 1.25rem);
  background-color: var(--hdr-accent);
}
.theme-toggle.dark .sun-icon {
  color: #94a3b8;
}
.theme-toggle.dark .moon-icon {
  color: #60a5fa;
}

/* Responsive */
@media (max-width: 768px) {
  .dashboard-header {
    padding: 0.75rem 1rem;
  }
  .header-button {
    display: none;
  }
  .notifications-dropdown {
    width: 280px;
    right: -48px;
  }
  .user-dropdown {
    right: -72px;
  }
}
@media (max-width: 640px) {
  .search-container {
    max-width: 160px;
  }
  .theme-toggle,
  .icon-button:not(.notification-button) {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Header/header.css"],"names":[],"mappings":"AAAA,+EAA+E;;AAE/E,qCAAqC;AACrC;EACE,iBAAiB;EACjB,qBAAqB;EACrB;oCACkC;EAClC,sBAAsB;EACtB,wBAAwB;;EAExB,mBAAmB;EACnB,oBAAoB;;EAEpB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;;EAExB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,0CAA0C;EAC1C,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,eAAe;EACf;gDAC8C;AAChD;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,sCAAsC;EACtC,sBAAsB;EACtB,+BAA+B;AACjC;AACA;;EAEE,0BAA0B;AAC5B;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,WAAW;EACX,2CAA2C;EAC3C,qBAAqB;EACrB,mCAAmC;EACnC,oCAAoC;EACpC,iBAAiB;EACjB;8BAC4B;AAC9B;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;;IAEI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;;AAEf;;AAEA,qDAAqD;AACrD;EACE,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,oCAAoC;EACpC,mCAAmC;EACnC,eAAe;EACf;0BACwB;AAC1B;AACA;EACE,sCAAsC;AACxC;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,mCAAmC;EACnC,sBAAsB;EACtB,4CAA4C;EAC5C,WAAW;EACX,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,0CAA0C;AAC5C;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,sCAAsC;EACtC,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,6CAA6C;EAC7C,uCAAuC;AACzC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,yBAAyB;AAC3B,EAAE,yBAAyB;;AAE3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,cAAc;AAChB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC,EAAE,iBAAiB;;AAEnB;EACE,SAAO;AACT;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,uCAAuC;EACvC,6BAA6B;EAC7B,eAAe;EACf,8DAA8D;AAChE;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,sBAAsB;EACtB,oCAAoC;EACpC,mCAAmC;EACnC,eAAe;EACf,8DAA8D;AAChE;AACA;EACE,sCAAsC;AACxC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;AACF;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,mCAAmC;EACnC,sBAAsB;EACtB,4CAA4C;EAC5C,WAAW;EACX,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,yDAAyD;AAC3D;AACA;EACE,oCAAoC;AACtC;AACA;EACE,iBAAiB;EACjB,uCAAuC;AACzC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,sCAAsC;EACtC,mCAAmC;EACnC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,8DAA8D;AAChE;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,0CAA0C;EAC1C,wDAAwD;AAC1D;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;;IAEE,aAAa;EACf;AACF","sourcesContent":["/* soft, minimal palette and refined interactions; keeps all your class names */\n\n/* Theme tokens (header-only scope) */\n:root {\n  --hdr-bg: #ffffff;\n  --hdr-border: #e6ebf2;\n  --hdr-shadow-sm: 0 1px 2px rgba(16, 24, 40, 0.06),\n    0 1px 3px rgba(16, 24, 40, 0.04);\n  --hdr-surface: #f8fafc;\n  --hdr-surface-2: #f1f5f9;\n\n  --hdr-text: #0f172a;\n  --hdr-muted: #64748b;\n\n  --hdr-accent: #2563eb;\n  --hdr-accent-600: #2563eb;\n  --hdr-accent-100: #eff6ff;\n  --hdr-accent-50: #f5faff;\n\n  --success: #16a34a;\n  --warning: #f59e0b;\n  --danger: #ef4444;\n}\n\n/* Header shell */\n.dashboard-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.875rem 1.25rem;\n  background-color: var(--hdr-bg);\n  border-bottom: 1px solid var(--hdr-border);\n  box-shadow: var(--hdr-shadow-sm);\n  position: relative;\n}\n\n/* Active section title */\n.active-section-display {\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n}\n.active-section-value {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--hdr-accent-600);\n  letter-spacing: 0.2px;\n}\n\n/* Buttons: menu/icon/ghost */\n.menu-button,\n.icon-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.25rem;\n  height: 2.25rem;\n  border-radius: 0.5rem;\n  color: var(--hdr-muted);\n  background-color: transparent;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: background-color 0.2s ease, color 0.2s ease,\n    border-color 0.2s ease, transform 0.08s ease;\n}\n.menu-button {\n  margin-right: 0.25rem;\n}\n.menu-button:hover,\n.icon-button:hover {\n  background-color: var(--hdr-surface-2);\n  color: var(--hdr-text);\n  border-color: var(--hdr-border);\n}\n.menu-button:active,\n.icon-button:active {\n  transform: translateY(1px);\n}\n\n/* Search (optional: add in JSX if you use it) */\n.search-container {\n  position: relative;\n  width: 100%;\n  max-width: 420px;\n}\n.search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #94a3b8;\n}\n.search-input {\n  width: 100%;\n  padding: 0.625rem 0.875rem 0.625rem 2.25rem;\n  border-radius: 0.5rem;\n  border: 1px solid var(--hdr-border);\n  background-color: var(--hdr-surface);\n  font-size: 0.9rem;\n  transition: box-shadow 0.2s ease, border-color 0.2s ease,\n    background-color 0.2s ease;\n}\n.search-input:focus {\n  outline: none;\n  border-color: var(--hdr-accent);\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);\n  background-color: #fff;\n}\n\n/* Right side actions */\n.header-actions {\n\n    display: flex;\n    flex-direction: row;\n    justify-content: right;\n    align-items: center;\n    /* flex-wrap: wrap; */\n    width: 100%;\n\n}\n\n/* Ghost button (Admin/Head/Employee/Partner Panel) */\n.header-button {\n  padding: 0.5rem 0.875rem;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--hdr-text);\n  background-color: var(--hdr-surface);\n  border: 1px solid var(--hdr-border);\n  cursor: pointer;\n  transition: background-color 0.2s ease, color 0.2s ease,\n    border-color 0.2s ease;\n}\n.header-button:hover {\n  background-color: var(--hdr-surface-2);\n}\n\n/* Notification badge */\n.notification-wrapper {\n  position: relative;\n}\n.notification-button {\n  position: relative;\n}\n.notification-badge {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  background-color: var(--danger);\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n  border: 2px solid #fff;\n}\n\n/* Notifications dropdown */\n.notifications-dropdown {\n  position: absolute;\n  top: calc(100% + 0.5rem);\n  right: 0;\n  width: 320px;\n  background-color: #fff;\n  border: 1px solid var(--hdr-border);\n  border-radius: 0.75rem;\n  box-shadow: 0 12px 24px rgba(2, 8, 20, 0.08);\n  z-index: 50;\n  overflow: hidden;\n  animation: slideDown 0.18s ease;\n}\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n.notifications-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 0.875rem;\n  border-bottom: 1px solid var(--hdr-border);\n}\n.notifications-header h3 {\n  margin: 0;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--hdr-text);\n}\n.close-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.75rem;\n  height: 1.75rem;\n  border-radius: 0.5rem;\n  color: var(--hdr-muted);\n  background: transparent;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.close-button:hover {\n  background-color: var(--hdr-surface-2);\n  color: var(--hdr-text);\n  border-color: var(--hdr-border);\n}\n\n.notifications-list {\n  max-height: 320px;\n  overflow-y: auto;\n}\n.notification-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.75rem 0.875rem;\n  border-bottom: 1px solid var(--hdr-surface-2);\n  transition: background-color 0.15s ease;\n}\n.notification-item:hover {\n  background-color: var(--hdr-surface);\n}\n.notification-item.unread {\n  background-color: var(--hdr-accent-50);\n}\n.notification-item.unread:hover {\n  background-color: var(--hdr-accent-100);\n}\n.notification-item.past-due {\n  background-color: #fef2f2;\n} /* soft red for overdue */\n\n.notification-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 0.5rem;\n  color: #fff;\n  flex-shrink: 0;\n}\n.notification-icon.blue {\n  background-color: var(--hdr-accent);\n}\n.notification-icon.green {\n  background-color: var(--success);\n}\n.notification-icon.amber {\n  background-color: var(--warning);\n}\n.notification-icon.red {\n  background-color: var(--danger);\n} /* for past-due */\n\n.notification-content {\n  flex: 1;\n}\n.notification-text {\n  margin: 0 0 0.25rem;\n  font-size: 0.9rem;\n  color: var(--hdr-text);\n  line-height: 1.4;\n}\n.notification-time {\n  margin: 0;\n  font-size: 0.75rem;\n  color: var(--hdr-muted);\n}\n\n.notifications-footer {\n  padding: 0.625rem;\n  border-top: 1px solid var(--hdr-border);\n  text-align: center;\n}\n.view-all {\n  width: 100%;\n  padding: 0.5rem;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--hdr-accent-600);\n  background-color: var(--hdr-accent-100);\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n.view-all:hover {\n  background-color: #e0efff;\n  border-color: #d2e4ff;\n}\n\n/* User profile + dropdown */\n.user-profile-wrapper {\n  position: relative;\n}\n.user-profile {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.625rem;\n  padding: 0.25rem 0.5rem 0.25rem 0.25rem;\n  border-radius: 0.75rem;\n  background-color: var(--hdr-surface);\n  border: 1px solid var(--hdr-border);\n  cursor: pointer;\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n.user-profile:hover {\n  background-color: var(--hdr-surface-2);\n}\n.user-avatar {\n  width: 2.25rem;\n  height: 2.25rem;\n  border-radius: 50%;\n  overflow: hidden;\n  border: 2px solid var(--hdr-border);\n  background-color: var(--hdr-surface-2);\n}\n.user-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.user-info {\n  display: none;\n}\n@media (min-width: 1024px) {\n  .user-info {\n    display: flex;\n    flex-direction: column;\n  }\n  .user-name {\n    font-size: 0.875rem;\n    font-weight: 600;\n    color: var(--hdr-text);\n  }\n  .user-role {\n    font-size: 0.75rem;\n    color: var(--hdr-muted);\n  }\n}\n\n.user-dropdown {\n  position: absolute;\n  top: calc(100% + 0.5rem);\n  right: 0;\n  width: 240px;\n  background-color: #fff;\n  border: 1px solid var(--hdr-border);\n  border-radius: 0.75rem;\n  box-shadow: 0 12px 24px rgba(2, 8, 20, 0.08);\n  z-index: 50;\n  overflow: hidden;\n  animation: slideDown 0.18s ease;\n}\n.user-dropdown-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.875rem;\n  border-bottom: 1px solid var(--hdr-border);\n}\n.user-dropdown-avatar {\n  width: 3rem;\n  height: 3rem;\n  border-radius: 50%;\n  overflow: hidden;\n  border: 2px solid var(--hdr-border);\n}\n.user-dropdown-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.user-dropdown-name {\n  margin: 0 0 0.25rem;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: var(--hdr-text);\n}\n.user-dropdown-email {\n  margin: 0;\n  font-size: 0.75rem;\n  color: var(--hdr-muted);\n}\n\n.user-dropdown-menu {\n  padding: 0.5rem 0;\n}\n.user-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  padding: 0.75rem 0.875rem;\n  color: var(--hdr-text);\n  text-decoration: none;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n.user-dropdown-item:hover {\n  background-color: var(--hdr-surface);\n}\n.user-dropdown-footer {\n  padding: 0.5rem 0;\n  border-top: 1px solid var(--hdr-border);\n}\n.user-dropdown-item.logout {\n  color: var(--danger);\n}\n.user-dropdown-item.logout:hover {\n  background-color: #fef2f2;\n}\n\n/* Theme toggle (if you wire it later) */\n.theme-toggle {\n  position: relative;\n  width: 3rem;\n  height: 1.5rem;\n  border-radius: 999px;\n  background-color: var(--hdr-surface-2);\n  border: 1px solid var(--hdr-border);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 0.25rem;\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n.theme-toggle::after {\n  content: \"\";\n  position: absolute;\n  left: 0.125rem;\n  top: 0.125rem;\n  width: 1.125rem;\n  height: 1.125rem;\n  border-radius: 50%;\n  background-color: #fff;\n  box-shadow: 0 1px 2px rgba(2, 8, 20, 0.12);\n  transition: left 0.25s ease, background-color 0.25s ease;\n}\n.theme-toggle .sun-icon {\n  color: #f59e0b;\n}\n.theme-toggle .moon-icon {\n  color: #94a3b8;\n}\n.theme-toggle.dark {\n  background-color: #0b1220;\n  border-color: #111827;\n}\n.theme-toggle.dark::after {\n  left: calc(100% - 1.25rem);\n  background-color: var(--hdr-accent);\n}\n.theme-toggle.dark .sun-icon {\n  color: #94a3b8;\n}\n.theme-toggle.dark .moon-icon {\n  color: #60a5fa;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .dashboard-header {\n    padding: 0.75rem 1rem;\n  }\n  .header-button {\n    display: none;\n  }\n  .notifications-dropdown {\n    width: 280px;\n    right: -48px;\n  }\n  .user-dropdown {\n    right: -72px;\n  }\n}\n@media (max-width: 640px) {\n  .search-container {\n    max-width: 160px;\n  }\n  .theme-toggle,\n  .icon-button:not(.notification-button) {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
